import React, { FC, useEffect, useState } from 'react'
import { Box, Fab } from '@material-ui/core'
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import FileInput, { TFile, FileInputProps } from './FileInput';
import PhotoCameraIcon from '@material-ui/icons/PhotoCamera';
import useToastMessage from 'hooks/useToastMessage';
import SolidSmallIconButton from 'Components/Buttons/SolidSmallIconButton';
import CloseIcon from '@material-ui/icons/Close';
import useConfirmationDialog from 'hooks/useConfirmationDialog';
import Loader from 'Components/Loader';
import { PictureModel } from 'Models/Pictures/Model';
import { Picture } from 'Models/Pictures/@types';

export interface PictureInputProps extends Omit<FileInputProps, 'onDone'> {
    onPicUpload?: (picture: Picture) => any;
    initialPicture?: Picture;
    enableReinitialization?: boolean;
    onPictureRemove?: () => any;
}

const PictureInput: FC<PictureInputProps> = (props) => {
    const classes = useStyles();
    const { onPicUpload, initialPicture, onPictureRemove, enableReinitialization = false, ...fileInputProps } = props;
    const [selectedPicture, setSelectedPicture] = useState<Picture | undefined>(initialPicture);
    const [uploading, setUploading] = useState(false);
    const withToast = useToastMessage();

    const withConfirmationDialog = useConfirmationDialog();

    useEffect(() => {
        if (enableReinitialization) setSelectedPicture(initialPicture);
    }, [initialPicture, enableReinitialization])

    const handleUpload = async (files: TFile[]) => {
        setUploading(true);
        await withToast(async () => {
            if (files.length < 1) { throw (new Error("File is not selected")) };
            const pic = await PictureModel.upload(files[0], files[0].name || 'Thumbnail', 't4k').catch(err => {
                setUploading(false);
                throw err;
            });
            onPicUpload?.(pic.data);
            setSelectedPicture(pic.data)
            return pic;
        }, { successToastMessage: 'Image Uploaded' });
        setUploading(false);
    }

    const handleRemovePicture = () => {
        withConfirmationDialog(() => {
            setSelectedPicture(undefined);
            onPictureRemove?.();
        }, { message: "You sure want to remove thumbnail?" })
    }

    return (
        <div className={classes.root} >
            {
                uploading ? <Loader />
                    : selectedPicture?.url ? <img className={classes.avatar} alt={'Content'} src={selectedPicture.url} /> : null
            }
            {
                (selectedPicture?.url || uploading) ? null :
                    <Fab disabled={uploading} color={'primary'} size={'small'} >
                        <FileInput onDone={(files) => handleUpload(files)} {...fileInputProps} />
                        <PhotoCameraIcon />
                    </Fab>
            }
            {
                selectedPicture?.url && !uploading ?
                    <Box position={'absolute'} bottom={0} left={'50%'} className={classes.delButtonContainer} >
                        <SolidSmallIconButton onClick={handleRemovePicture} leftGutter={false} ><CloseIcon fontSize={'small'} /></SolidSmallIconButton>
                    </Box> : null
            }
        </div>
    )
}

const useStyles = makeStyles<Theme>((theme) => {
    return (createStyles({
        root: {
            display: 'flex',
            justifyContent: "center",
            position: 'relative',
            width: '100%',
        },
        avatar: {
            width: '100%',
            height: 'auto',
        },
        delButtonContainer: {
            position: 'absolute',
            bottom: 0,
            left: '50%',
            transform: 'translate(-10px, 10px)'
        }
    }))
})

export default PictureInput